import React, { useState, useEffect } from 'react';
import './App.scss'
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from 'react-router-dom'; 
import { AuthProvider } from './context/AuthContext'; 
import Login from './pages/Login';
import PrivateRoute from './components/PrivateRoute'; 
import Subhospital from './pages/Admin/Subhospital';
import AdminPatientList from './pages/Admin/AdminPatientList';
import Dashboard from './pages/Admin/Dashboard';
import ReceptionistManagement from './pages/Admin/ReceptionistManagement';
import DoctorAvailability from './pages/Admin/DoctorAvailability';
import DoctorDashboard from './pages/Doctor/DoctorDashboard';
import PatientDashboard from './pages/Patient/PatientDashboard';
import ReceptionistDashboard from './pages/Receptionist/ReceptionistDashboard';
import LabDashboard from './pages/Lab/LabDashboard';
import Header from './components/Header';
import Footer from './components/Footer'; // Import the Footer component
import SuperadminDashboard from './pages/Superadmin/SuperadminDashboard';
import HospitalDetail from './pages/Superadmin/HospitalDetail'; // Import HospitalDetail
import HospitalDetails from './pages/Superadmin/HospitalDetails'; // Add this line
import Brochure from './pages/Superadmin/Brochure';
import SubHospitalDetails from './pages/SubHospital/SubHospitalDetails'; // Import SubHospitalDetails
import ManageUsers from './pages/Admin/ManageUsers'; // Import ManageUsers
import ReceptionistPatientAppointmnet from './pages/Receptionist/ReceptionistPatientAppointmnet'; // Ensure this import exists
import BookAppointmentPage from './pages/Receptionist/BookAppointmentPage'; // Import the new page
import Appointment from './pages/Patient/Appointment'; // Import Appointment
import PublicPatientForm from './pages/Patient/PublicPatientForm'; // Import PublicPatientForm
import Prescription from './pages/Doctor/Prescription';
import Notification from './pages/Notification'; // Import Notification
import LabTest from './pages/Doctor/LabTest'; // Import LabTest
import Reports from './pages/Lab/Reports'; // Import Reports
import PatientReport from './pages/Patient/PatientReport'; // Import PatientReport
import { Toaster } from 'react-hot-toast';
import { NotificationProvider } from './context/NotificationContext'; // Import NotificationProvider
import { SidebarProvider } from "./context/SidebarContext";
import Sidebar, { SidebarWidthContext } from './components/Sidebar';
import TimeLogButton from './components/TimeLogButton'; // Import TimeLogButton
import InactivityLogout from './components/InactivityLogout';
import ScrollToTop from './components/ScrollToTop'; // Import ScrollToTop
import AddLabTest from './pages/Admin/AddLabTest'; 
import BlogPage from './pages/Superadmin/BlogPage'
import LandingPage from './pages/LandingPage'
import NotFound from './pages/NotFound'
import Enuirepage from './pages/Superadmin/EnquirePage'
import About from './pages/Main/About';
import Plans from './pages/Main/Plans';
import Feature from './pages/Main/Feature';
import PlanDetails from './pages/Main/PlanDetails';
import ModulePage from './pages/Main/ModulePage';
import Blogs1 from './pages/Main/Blogs1';
import Blogs2 from './pages/Main/Blogs2';



const BASE_URL = process.env.REACT_APP_BASE_URL;



const AppContent = () => {
  const [sidebarWidth, setSidebarWidth] = useState(70);
  const location = useLocation();
  const hideSidebar =
  location.pathname === '/login' ||
  location.pathname === '/public-patient-form';

    const hideHeader =
    location.pathname === '/login' ||
    location.pathname === '/public-patient-form';

  const showFooter = location.pathname === "/";
  const publicRoutes = [
  "/login",
  "/",
  "/about-us",
  "/plans",
  "/features",
  "/blogs1",
  "/public-patient-form",
];

  const isPublicRoute =
  publicRoutes.includes(location.pathname) ||
  location.pathname.startsWith("/blogs2") ||
  location.pathname.startsWith("/plan") ||
  location.pathname.startsWith("/service");

const shouldApplyPadding = !isPublicRoute;
  
  useEffect(() => {
    const handleBeforeUnload = () => {
      const storedUser = JSON.parse(localStorage.getItem('user'));
      const userId = storedUser?.id;

      if (userId) {
        navigator.sendBeacon(
          `${BASE_URL}/api/auth/logout`,
          new Blob([JSON.stringify({ userId })], { type: 'application/json' }),
        );
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, []);


  return (
    <SidebarWidthContext.Provider value={sidebarWidth}>
    <div >
       {!hideSidebar && (
        <div style={{ width: sidebarWidth, transition: "width 0.3s" }}>
          <Sidebar onWidthChange={setSidebarWidth} />
        </div>
      )}
     
      
      <div >
        <InactivityLogout /> 
        {!hideHeader && <Header />} 
      </div>
       
       
     
        <div className={`flex-fill ${
    shouldApplyPadding ? "p-2 p-md-5 mx-2 mt-5 mt-md-1" : ""
  }`}
        >

          <ScrollToTop />
        <Toaster position="top-right" reverseOrder={true} />
        <Routes>
          {/* Public Routes */}

          <Route path="/" element={<LandingPage />} />
          <Route path="/login" element={<Login />} />
           <Route path="*" element={<NotFound />} />
          <Route path="/about-us" element={<About />} />
          <Route path="/plans" element={<Plans />} />
          <Route path="/features" element={<Feature />} />
          <Route path="/plan/:planType" element={<PlanDetails />} />
          <Route path="/service/:serviceType" element={<ModulePage  />} />
          <Route path="/blogs1" element={<Blogs1 />} />
          <Route path="/blogs2/:id" element={<Blogs2 />} />

           


          {/* Protected Routes */}
          <Route
            path="/watch-time"
            element={<PrivateRoute element={<TimeLogButton />} />}
          />
          <Route
            path="/super_admin"
            element={<PrivateRoute element={<SuperadminDashboard />} />}
          />
           <Route
            path="/enquire-page"
            element={<PrivateRoute element={<Enuirepage />} />}
          />
           <Route
            path="/brochure-page"
            element={<PrivateRoute element={<Brochure />} />}
          />
          <Route
            path="/admin"
            element={<PrivateRoute element={<Dashboard />} />}
          />
          <Route
            path="/admin_patient_list"
            element={<PrivateRoute element={<AdminPatientList />} />}
          />
          <Route
            path="/addlabTest"
            element={<PrivateRoute element={<AddLabTest />} />}
          />
          <Route
            path="/admin-subhospital"
            element={<PrivateRoute element={<Subhospital />} />}
          />
          <Route
            path="/admin_doctor"
            element={<PrivateRoute element={<DoctorAvailability />} />}
          />
          <Route
            path="/doctor"
            element={<PrivateRoute element={<DoctorDashboard />} />}
          />
          <Route
            path="/patient"
            element={<PrivateRoute element={<PatientDashboard />} />}
          />
          <Route
            path="/patient_report"
            element={<PrivateRoute element={<PatientReport />} />}
          />
          <Route
            path="/lab_test"
            element={<PrivateRoute element={<LabTest />} />}
          />
          <Route
            path="/report"
            element={<PrivateRoute element={<Reports />} />}
          />
          <Route
            path="/prescription"
            element={<PrivateRoute element={<Prescription />} />}
          />
          <Route
            path="/patient_appointment"
            element={<PrivateRoute element={<Appointment />} />}
          />
          <Route
            path="/receptionist"
            element={<PrivateRoute element={<ReceptionistDashboard />} />}
          />
          <Route
            path="/receptionist_patient_appointment"
            element={
              <PrivateRoute element={<ReceptionistPatientAppointmnet />} />
            }
          />
          <Route
            path="/receptionist/book-appointment"
            element={<PrivateRoute element={<BookAppointmentPage />} />}
          />
          <Route
            path="/lab"
            element={<PrivateRoute element={<LabDashboard />} />}
          />
          <Route
            path="/superadmin/hospitals/:hospitalId"
            element={<PrivateRoute element={<HospitalDetail />} />}
          />{' '}
          {/* New route for HospitalDetail */}
          <Route
            path="/hospitalDetails/:hospitalId"
            element={<PrivateRoute element={<HospitalDetails />} />}
          />{' '}
          {/* Add this line */}
          <Route
            path="/subHospital/:subHospitalId"
            element={<PrivateRoute element={<SubHospitalDetails />} />}
          />{' '}
          {/* New route for SubHospitalDetails */}
          <Route
            path="/manage-users"
            element={<PrivateRoute element={<ManageUsers />} />}
          />{' '}
          <Route
            path="/blogs"
            element={<PrivateRoute element={<BlogPage />} />}
          />
          {/* Add this line */}
          <Route path="/logout" element={<Navigate to="/login" />} />
          <Route
            path="/receptionist_management"
            element={<PrivateRoute element={<ReceptionistManagement />} />}
          />
          <Route
            path="/notification"
            element={<PrivateRoute element={<Notification />} />}
          />{' '}
          {/* Notification page */}
          {/* Redirect to login if no route matches */}
          <Route path="/" element={<Navigate to="/landing-page" />} />
          <Route
            path="/public-patient-form"
            element={<PublicPatientForm />}
          />{' '}
          {/* Public Patient Form */}
        </Routes>
        {showFooter && <Footer />}
      </div>
    </div>     
    </SidebarWidthContext.Provider>
  );
};

const App = () => (
  <Router>
    <AuthProvider>
      <NotificationProvider>
         <SidebarProvider>
           <AppContent />
         </SidebarProvider>
      </NotificationProvider>
    </AuthProvider>
  </Router>
);

export default App;
